
<aside id="sidebar_left">
    <div class="sidebar-left-content nano-content">
        
        <a href="/" class="pull-left mr20 ml20" style="margin:7px">
            <img src="img/logist.png" alt="Logist" class="mw100">
        </a>
        
        <ul class="nav sidebar-menu">
                <!--

            <li class="dropdown m10 hidden-xs" id="eTeamDropDown">
                <button class="btn btn-primary btn-sm dropdown-toggle" type="button" data-toggle="dropdown"> 
                    {{ $root.selectedTeamName.name }}
                </button>
                <ul class="dropdown-menu">
                    <li ng-repeat="team in authenticatedUser.teams" ng-click="selectedTeam(team)"><a href="#">{{ team.name }}</a></li>
                </ul>
            </li>
                -->

            <li class="dropdown visible-xs">
                <a class="fs14" href="/map" ng-click="getHome('map')">
                    Harita
                </a>
            </li>
            <li class="dropdown visible-xs">
                <a class="fs14" href="/projeler" ng-click="getHome('projeler')">
                    Ofis
                </a>
            </li>

            <li class="dropdown hidden-xs" ng-class="{ active: isActive('/map')}">
                <a class="fs14" href="/map" ng-click="getHome('map')">
                    <span class="fa fa-globe"></span> Harita
                </a>
            </li>
            <li class="dropdown hidden-xs" ng-class="{ active: isActive('/liste')}">
                <a class="fs14" href="/orders" ng-click="getHome('orders')">
                    <span class="fa fa-list"></span> Yük Yönetimi
                </a>
            </li>

            <li class="dropdown hidden-xs" ng-class="{ active: isActive('/sefer-listesi')}">
                <a href="sefer-listesi" class="">
                    <i class="fa fa-plus"></i> Sefer Yönetimi
                </a>
            </li>
        
    
            <li class="pull-right visible-xs">
                <a href="menu-profil">
                    <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ authenticatedUser.logo }}" alt="avatar" class="mw30">
                    <span class="hidden-xs hidden-sm"><name> {{ authenticatedUser.company_name | cut:true:20:' ...' }}</name> </span>
                    <span class="fa fa-caret-down hidden-xs mr15"></span>
                </a>
            </li>
            
            <li class="nav navbar-nav navbar-left dropdown pull-right hidden-xs" id="eCompanyDropDown">
                <a href="#" class="dropdown-toggle">
                    <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ authenticatedUser.logo }}" alt="avatar" class="mw30">
                    
                    <span class="hidden-xs hidden-sm"><name> {{ authenticatedUser.company_name | cut:true:20:' ...' }}</name> </span>
                    <span class="fa fa-caret-down hidden-xs mr15"></span>
                </a>
                <ul class="nav sub-nav" role="menu">
                    <li>
                        <a class="fs14" href="/ayarlar/profile"> 
                        <i class="fa fa-wrench"></i> Şirket Bilgileri</a>
                    </li>
                    <li>
                        <a class="fs14" href="/ayarlar/change-password"> 
                        <i class="fa fa-key"></i> Şifre Değiştir</a>
                    </li>
                    <li>
                        <a class="fs14" href="#" ng-click="logout()"> 
                        <i class="fa fa-power-off"></i> Güvenli Çıkış </a>
                    </li>
                </ul>
            </li>

            <li class="pull-right visible-xs">
                <a href="/menu" class="fw600">
                    <i class="fa fa-bars fs18"></i>
                </a>
            </li>

            <li class="nav navbar-nav navbar-left dropdown pull-right dropdown hidden-xs">
                <a href="#" class="dropdown-toggle fw600" data-toggle="dropdown" id="eDropdown">
                    <i class="fa fa-bars fs18"></i>
                </a>
                <ul class="nav sub-nav" role="menu">
                    
                    <li ng-if="authenticatedUser.authorization.analytics">
                        <a class="fs14" href="/raporlar/sefer">
                            <span class="fa fa-line-chart"></span> Raporlar
                        </a>
                    </li>
                    
                    <li ng-if="authenticatedUser.authorization.customer">
                        <a class="fs14" href="/musteri-yonetimi" id="e5">
                            <span class="fa fa-university"></span> Müşteri Yönetimi
                        </a>
                    </li>
                    
                    <li ng-if="authenticatedUser.authorization.supplier">
                        <a class="fs14" href="/tedarikci-yonetimi" id="e5">
                            <span class="fa fa-building"></span> Tedarikçi Yönetimi
                        </a>
                    </li>

                    <li ng-if="authenticatedUser.authorization.worker">
                        <a class="fs14" href="/calisan-yonetimi">
                            <span class="fa fa-user" id="e0"></span> Çalışan Yönetimi
                        </a>
                    </li>
                    
                    <li ng-if="authenticatedUser.authorization.team">
                        <a class="fs14" href="/ekip-yonetimi">
                            <span class="fa fa-users"></span> Ekip Yönetimi
                        </a>
                    </li>

                    <li ng-if="authenticatedUser.authorization.user">
                        <a class="fs14" href="/users">
                            <span class="fa fa-male"></span> Yetkili Yönetimi
                        </a>
                    </li>

                    <li ng-if="authenticatedUser.authorization.office_work">
                        <a class="fs14" href="/projeler" ng-click="getHome('projeler')">
                            <span class="fa fa-tasks"></span> Ofis İşleri</span>
                        </a>
                    </li>
                
                    <li ng-if="authenticatedUser.authorization.recipe">
                        <a href="/tarife-yonetimi">
                            <i class="fa fa-tasks"></i> 
                            <span>Tarife Yönetimi</span>
                        </a>
                    </li>

                    <li ng-if="authenticatedUser.authorization.recipe">
                        <a href="/zone">
                            <i class="fa fa-flag"></i> 
                            <span>Zone Yönetimi</span>
                        </a>
                    </li>

                    <li ng-if="authenticatedUser.authorization.form">
                        <a href="/ayarlar/formlar">
                            <i class="fa fa-list-alt"></i>
                            <span>Özel Formlar</span>
                        </a>
                    </li>

                    <li ng-if="authenticatedUser.authorization.setting">
                        <a href="/ayarlar/eklentiler">
                            <i class="fa fa-plug"></i>
                            <span>Eklentiler & Ayarlar</span>
                        </a>
                    </li>

                    <li class="dropdown-footer text-center">
                    </li>

                </ul>
            </li>
        </ul>
    </div>
</aside>
<div class="clearfix"></div>